import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from './LegalPageLayout';

// NOTE: Draft. Replace with your finalized privacy language when ready.

export default function PrivacyPage() {
  const effectiveDate = 'February 1, 2026';
  return (
    <LegalPageLayout
      title="Privacy Policy"
      subtitle={`Effective ${effectiveDate}. This explains what we collect, why, and your choices.`}
    >
      <section>
        <h2 className="text-xl font-heading font-semibold text-white mt-2 mb-2">Information we collect</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Account information</strong> — your name, email, service title, and profile photo.</li>
          <li><strong>Payment identity data</strong> — collected and processed by Stripe under its own Privacy Policy. Golden Tips does not store your bank account or SSN.</li>
          <li><strong>Tip data</strong> — amount, praise tags, and optional notes attached to each tip.</li>
          <li><strong>Usage data</strong> — page views, actions, and device information used to keep the Service reliable and secure.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-heading font-semibold text-white mt-2 mb-2">How we use your information</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>To operate the Service (deliver tips, run payouts, generate your public page and QR code).</li>
          <li>To calculate rankings and pool contributions for the Top Earner Challenge.</li>
          <li>To communicate service-critical notices (password resets, payout issues, security alerts).</li>
          <li>To detect and prevent fraud, abuse, and violations of our{' '}
            <Link to="/terms" className="text-[#F5C542] hover:underline">Terms of Service</Link>.
          </li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-heading font-semibold text-white mt-2 mb-2">Sharing</h2>
        <p>
          We share the minimum information necessary with the vendors that
          run Golden Tips: <strong>Stripe</strong> (payments and identity
          verification) and cloud infrastructure providers. We do not sell
          personal information, and we do not share it with advertisers.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-heading font-semibold text-white mt-2 mb-2">Guest tippers</h2>
        <p>
          If you send a tip as a guest, Golden Tips receives the amount, an
          optional note or praise tag, and the payment method type from
          Stripe. We do not store your card number — that is handled entirely
          by Stripe.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-heading font-semibold text-white mt-2 mb-2">Cookies &amp; storage</h2>
        <p>
          We use browser storage to keep you signed in and to remember basic
          UI preferences. We do not use tracking cookies for advertising.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-heading font-semibold text-white mt-2 mb-2">Security</h2>
        <p>
          Passwords are hashed with bcrypt. Payment identity data is
          tokenized by Stripe. All traffic is served over TLS. Only
          authorized team members and vendors that support the Service have
          access to production data.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-heading font-semibold text-white mt-2 mb-2">Your rights</h2>
        <p>
          Depending on where you live, you may have rights to access,
          correct, port, or delete your personal information. To make a
          request, email us via{' '}
          <Link to="/contact" className="text-[#F5C542] hover:underline">/contact</Link>{' '}
          and we will respond within 30 days.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-heading font-semibold text-white mt-2 mb-2">Children</h2>
        <p>
          Golden Tips is not intended for people under 18. We do not
          knowingly collect information from children.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-heading font-semibold text-white mt-2 mb-2">Changes to this policy</h2>
        <p>
          When we make material changes to this policy, we will post a
          notice at the top of this page and, where required by law, notify
          you by email.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-heading font-semibold text-white mt-2 mb-2">Contact</h2>
        <p>
          Questions or requests?{' '}
          <Link to="/contact" className="text-[#F5C542] hover:underline">Contact us</Link>.
        </p>
      </section>
    </LegalPageLayout>
  );
}
